import { DriveRecorderFirmwareHandler } from '../modules/drive-recorder-firmware-handler.js';
import { DriveRecorderSettingHandler } from '../modules/drive-recorder-setting-handler.js';
import { SelectHelper } from '../modules/select-helper.js';

if (is_route('drive_recorder.index')) {
    const observeOnce = (condition, callback) => {
        const observer = new MutationObserver(() => {
            if (condition()) {
                callback();
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    };

    observeOnce(
        () => $('[data-drive-recorder-firmware-update-release-button-on-change="true"]').length,
        () => {
            $('[data-drive-recorder-firmware-update-release-button-on-change="true"]')
                .trigger('change');
        },
    );

    /**
     * マルチセレクト全解除時に URL に残る配列パラメータを削除します。
     *
     * 共通スクリプトの set_parameters() は配列非対応のため、
     * 未選択でも categories[] が URL に残り再検索に使われてしまう。
     * 既存実装を変更せず、不整合を防ぐため URL から完全に削除します。
     */
    const removeArrayParam = (paramName) => {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        params.delete(paramName + '[]');

        history.replaceState(null, '', url.toString());
    };

    $(document).on('amc:onload', () => {
        removeArrayParam('categories');
        drive_recorder_event_set();
        drive_recorder_vehicle_device_event_set();
        drive_recorder_setting_event_set();
        drive_recorder_firmware_event_set();
    });

    $(document).on('amc:reload', () => {
        removeArrayParam('categories');
    });
}

// ==================================================
// ドラレコ
// ==================================================
window.drive_recorder_event_set = () => {
    const search = (options = {}) => {
        const baseConditions = $('#search-form').serializeArray();

        baseConditions.push({
            name: 'keyword',
            value: $('#toolbar-keyword-search').val(),
        });

        const companyId = baseConditions
            .filter(item => item.name === 'company_id')
            .pop()?.value;

        const normalizedByCompanyConditions = companyId === ''
            ? baseConditions.map(item => item.name === 'section_id'
                ? { ...item, value: '' }
                : item
            )
            : baseConditions;

        const normalizedConditions = options.clearSectionId
            ? normalizedByCompanyConditions
                .filter(item => item.name !== 'section_id')
            : normalizedByCompanyConditions;

        const excutionData = ['holding_id', 'company_id', 'section_id', 'mode'];
        const action = $('#search-form').attr('action').replace('/search', '');
        const url = _request.create_affiliation_url(action, true, normalizedConditions, excutionData);

        location.href = url;
    };

    // ===============================
    // 会社セレクトの変更時に検索します。
    // ===============================
    $(document).on('change', '#search-form-company_id', (event) => {
        event.stopPropagation();

        search({ clearSectionId: true });
    });

    // ===============================
    // 営業所セレクトの変更時に検索します。
    // ===============================
    $(document).on('change', '#search-form-section_id', (event) => {
        event.stopPropagation();

        search();
    });

    // ===============================
    // 検索ボタンのクリック時に検索します。
    // ===============================
    $(document).on('click', '[data-search-button]', (event) => {
        event.preventDefault();
        $(event.currentTarget).prop('disabled', true);
        search();
    });

    // ====================================================================================================
    // [data-mode-tab] 付き要素のクリック時に、タブを変更して検索します。
    // ====================================================================================================
    $(document).on('click', '[data-mode-tab]', (event) => {
        event.preventDefault();
        const mode = $(event.currentTarget).data('mode-tab');
        $('input[name="mode"]').val(mode);
        $('[data-mode-tab]').removeClass('active');
        $(event.currentTarget).addClass('active');
        search();
    });

    // ====================================================================================================
    // [data-modal] 付き要素のクリック時に、モーダルを作成します。
    // ====================================================================================================
    $(document).on('click', '[data-modal]', (event) => {
        const element = event.currentTarget;
        const modalType = $(element).data('modal');
        const modalId = $(element).data(`modal-${modalType}`);
        _modal.create(element, modalId, Object.keys($(element).data()));
    });

    // ====================================================================================================
    // [data-modal-action] 付き要素のクリック時に、モーダルのアクションを実行します。
    // ====================================================================================================
    $(document).on('click', '[data-modal-action]', (event) => {
        const element = event.currentTarget;
        const modalType = $(element).data('modal-action');
        const modalId = `modal-action-${modalType}`;
        _modal.submit(element, modalId, null, null, '-form', false, () => {
            if ($('body').hasClass('modal-open')) {
                $('.modal.show').modal('hide');
            }
        });
    });

    // ====================================================================================================
    // [data-modal-container] 付きモーダルが閉じられる直前に、内部フォーカスを解除して `aria-hidden` 警告を回避します。
    // ====================================================================================================
    $(document).on('hide.bs.modal', '[data-modal-container]', (event) => {
        const element = event.currentTarget;
        $(element).find(':focus').trigger('blur');
    });

    // ====================================================================================================
    // [data-drive-recorder-checkbox-all] 付き要素の変更時に、
    // 対応する [data-drive-recorder-checkbox] のチェック状態を一括更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-checkbox-all]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');
        const target = $(element).data('drive-recorder-checkbox-all');
        const isChecked = $(element).prop('checked');
        $scope.find(`[data-drive-recorder-checkbox="${target}"]`).not(':disabled').prop('checked', isChecked);
    });

    // ====================================================================================================
    // [data-drive-recorder-checkbox] 付き要素の変更時に、
    // 対応する [data-drive-recorder-checkbox-all] のチェック状態を同期します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-checkbox]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');
        const target = $(element).data('drive-recorder-checkbox');
        const $all = $scope.find(`[data-drive-recorder-checkbox="${target}"]`).not(':disabled');
        const checked = $all.filter(':checked').length;
        $scope.find(`[data-drive-recorder-checkbox-all="${target}"]`).prop('checked', checked === $all.length);
    });

    // ====================================================================================================
    // [data-drive-recorder-on-holding-select-change="true"] 付き要素の変更時に、
    // 選択されたグループ会社に応じて会社セレクト、ドラレコセレクトを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-on-holding-select-change="true"]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-drive-recorder-on-company-select-change="true"]');
            SelectHelper.clear(element, '[data-drive-recorder-on-drive-recorder-select-change="true"]');
            return;
        }

        const holdingId = $(element).val();
        const driveRecorderId = $scope.find('[data-drive-recorder-on-drive-recorder-select-change="true"]')
            .data('default');

        SelectHelper.update(element, '[data-drive-recorder-on-company-select-change="true"]', {
            holding_id: holdingId,
        });

        SelectHelper.update(element, '[data-drive-recorder-on-drive-recorder-select-change="true"]', {
            holding_id: holdingId,
            exclude_attached: true,
            ...(driveRecorderId ? { except_ids: [driveRecorderId] } : {}),
        });
    });

    // ====================================================================================================
    // [data-drive-recorder-on-company-select-change="true"] 付き要素の変更時に、
    // 選択された会社に応じて営業所セレクト、ドラレコセレクトを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-on-company-select-change="true"]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-drive-recorder-on-section-select-change="true"]');
            return;
        }

        const holdingId = $scope.find('[data-drive-recorder-on-holding-select-change="true"]').val();
        const companyId = $(element).val();
        const driveRecorderId = $scope.find('[data-drive-recorder-on-drive-recorder-select-change="true"]')
            .data('default');

        SelectHelper.update(element, '[data-drive-recorder-on-section-select-change="true"]', {
            holding_id: holdingId,
            company_id: companyId,
        });

        SelectHelper.update(element, '[data-drive-recorder-on-drive-recorder-select-change="true"]', {
            holding_id: holdingId,
            company_id: companyId,
            exclude_attached: true,
            ...(driveRecorderId ? { except_ids: [driveRecorderId] } : {}),
        });
    });

    // ====================================================================================================
    // [data-drive-recorder-on-section-select-change="true"] 付き要素の変更時に、
    // 選択された営業所に応じて車両セレクト、ドラレコセレクトを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-on-section-select-change="true"]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-drive-recorder-on-vehicle-select-change="true"]');
            return;
        }

        const holdingId = $scope.find('[data-drive-recorder-on-holding-select-change="true"]').val();
        const companyId = $scope.find('[data-drive-recorder-on-company-select-change="true"]').val();
        const sectionId = $(element).val();
        const vehicleId = $scope.find('[data-drive-recorder-on-vehicle-select-change="true"]')
            .data('default');
        const driveRecorderId = $scope.find('[data-drive-recorder-on-drive-recorder-select-change="true"]')
            .data('default');

        SelectHelper.update(element, '[data-drive-recorder-on-vehicle-select-change="true"]', {
            holding_id: holdingId,
            company_id: companyId,
            section_id: sectionId,
            exclude_attached: true,
            ...(vehicleId ? { except_ids: [vehicleId] } : {}),
        });

        SelectHelper.update(element, '[data-drive-recorder-on-drive-recorder-select-change="true"]', {
            holding_id: holdingId,
            company_id: companyId,
            section_id: sectionId,
            exclude_attached: true,
            ...(driveRecorderId ? { except_ids: [driveRecorderId] } : {}),
        });
    });

    // ====================================================================================================
    // [data-drive-recorder-on-drive-recorder-select-change="true"] 付き要素の変更時に、
    // 選択されたドラレコに応じてドラレコ設定セレクトを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-on-drive-recorder-select-change="true"]', (event) => {
        const element = event.currentTarget;
        const $scope = $(element).closest('.modal-body');

        if ($(element).find('option:selected').length === 0 || $(element).find('option:selected').val() === '') {
            SelectHelper.clear(element, '[data-drive-recorder-on-drive-recorder-setting-select-change="true"]');
            return;
        }

        const holdingId = $scope.find('[data-drive-recorder-on-holding-select-change="true"]').val();
        const companyId = $scope.find('[data-drive-recorder-on-company-select-change="true"]').val();
        const sectionId = $scope.find('[data-drive-recorder-on-section-select-change="true"]').val();
        const driveRecorderId = $(element).val();
        const defaultsOnly = $scope.find('[data-drive-recorder-on-drive-recorder-setting-select-change="true"]')
            .data('drive-recorder-on-drive-recorder-setting-select-defaults-only');

        SelectHelper.update(element, '[data-drive-recorder-on-drive-recorder-setting-select-change="true"]', {
            holding_id: holdingId,
            company_id: companyId,
            section_id: sectionId,
            drive_recorder_id: driveRecorderId,
            defaults_only: defaultsOnly === true,
        });
    });

    $(document).on('shown.bs.modal', '#modal-add, #modal-edit, #modal-upload', (event) => {
        const $modal = $(event.currentTarget);

        $modal.find('select.select2')
            .select2('destroy')
            .select2({
                closeOnSelect: true,
                dropdownParent: $modal,
                width: '100%',
            });
    });

    $(document).on('shown.bs.modal', '#modal-add, #modal-upload', (event) => {
        const $modal = $(event.currentTarget);

        const $sectionSelects = $modal.find('select[data-drive-recorder-on-section-select-change="true"]');
        const hasSectionValue = $sectionSelects.toArray()
            .some(element => $(element).val());

        if (hasSectionValue) {
            $sectionSelects.each((_, element) => $(element).trigger('change'));

            return;
        }

        const $companySelects = $modal.find('select[data-drive-recorder-on-company-select-change="true"]');
        const hasCompanyValue = $companySelects.toArray()
            .some(element => $(element).val());

        if (hasCompanyValue) {
            $companySelects.each((_, element) => $(element).trigger('change'));

            return;
        }

        $modal.find('select[data-drive-recorder-on-holding-select-change="true"]')
            .each((_, element) => {
                if ($(element).val()) {
                    $(element).trigger('change');
                }
            });
    });

    $(document).on('shown.bs.modal', '#modal-edit', (event) => {
        const $modal = $(event.currentTarget);

        const $active = $('a[data-mode-tab].active');
        const mode = $active.length ? $active.data('mode-tab') : 'index';

        const $sectionSelects = $modal.find('select[data-drive-recorder-on-section-select-change="true"]');
        const hasSectionValue = $sectionSelects.toArray()
            .some(element => $(element).val());

        if (hasSectionValue) {
            // ====================================================================================================
            // ドラレコ設定の車両一括設定の初期表示では、営業所セレクトの `change` をトリガーしないと
            // テーブルが描画されないため、明示的に `change` イベントを発火させて初期化します。
            // ====================================================================================================
            if (mode === 'setting') {
                $sectionSelects.each((_, element) => $(element).trigger('change'));
            }

            return;
        }

        const $companySelects = $modal.find('select[data-drive-recorder-on-company-select-change="true"]');
        const hasCompanyValue = $companySelects.toArray()
            .some(element => $(element).val());

        if (hasCompanyValue) {
            $companySelects.each((_, element) => $(element).trigger('change'));

            return;
        }

        $modal.find('select[data-drive-recorder-on-holding-select-change="true"]')
            .each((_, element) => {
                if ($(element).val()) {
                    $(element).trigger('change');
                }
            });
    });

    // ====================================================================================================
    // ファイル名を表示
    // ====================================================================================================
    $(document).on('change', 'input[type="file"]', (event) => {
        const element = event.currentTarget;

        const display = $(element).closest('label').next('.file-name-display');

        if (element.files.length) {
            display.text(element.files[0].name);
        } else {
            display.text('');
        }
    });

    $(document).on('click', 'input[type="file"][name="csv_file"]', (event) => {
        const element = event.currentTarget;

        // 同一ファイルの再選択のために値をクリア
        element.value = '';

        // ファイル名の表示をクリア
        $(element).closest('label').next('.file-name-display').text('');
    });

    $(document).on('change', 'input[type="file"][name="csv_file"]', (event) => {
        const element = event.currentTarget;

        // アップロードモーダルの body / footer を取得
        const modalBody = $(element).closest('[data-upload-modal-body]');
        const modalFooter = modalBody.siblings('[data-upload-modal-footer]');

        // 送信ボタンとモーダル・フォームの識別子を取得
        const submit = modalFooter.find('[data-modal-action-with-file]');
        const submitModalType = submit.data('modal-action-with-file');
        const submitModalIdRaw = submit.data(`modal-action-with-file-${submitModalType}`);
        const submitModalId = submitModalIdRaw.startsWith('#') ? submitModalIdRaw : '#' + submitModalIdRaw;

        // モーダル ID からフォーム ID を生成（先頭の # を除去して -form を付与）
        const submitFormId = (submitModalId + '-form').substring(1);
        const submitForm = document.getElementById(submitFormId);

        $(`${submitModalId}-csv_file-csv-submit-messages`).addClass('display-none');
        $(`${submitModalId}-csv_file-csv-submit-messages`).empty();
        $(`${submitModalId}-csv_file-csv-submit-button`).prop('disabled', true);

        $(`${submitModalId}-csv_file-csv-error-messages`).addClass('display-none');
        $(`${submitModalId}-csv_file-csv-error-messages`).empty();

        // フォームのモードをアップロード検証用に切り替え
        modalBody.find('input[name="mode"]').val($(submitForm).data('upload-validate-mode'));

        // フォームの送信先をアップロード検証用エンドポイントに切り替え
        $(submitForm).attr('action', $(submitForm).data('upload-validate-url'));

        // アップロード検証用エンドポイントにファイルを送信
        _ajax.file(submitForm.action, new FormData(submitForm), (response) => {
            // フォームのモードをアップロード用に切り替え
            modalBody.find('input[name="mode"]').val($(submitForm).data('upload-mode'));

            // フォームの送信先をアップロード用エンドポイントに切り替え
            $(submitForm).attr('action', $(submitForm).data('upload-url'));

            $(`${submitModalId}-csv_file-csv-submit-messages`).removeClass('display-none');
            $(`${submitModalId}-csv_file-csv-submit-messages`).text(response.messages[0]);
            $(`${submitModalId}-csv_file-csv-submit-button`).prop('disabled', false);
        }, (xhr, status, errorThrown) => {
            $.each(xhr.responseJSON.errors, (name, message) => {
                $(`${submitModalId}-csv_file-csv-error-messages`).removeClass('display-none');
                $(`${submitModalId}-csv_file-csv-error-messages`).append($('<li></li>').text(message));
            });
        });
    });
};

// ==================================================
// 取り付け状況
// ==================================================
window.drive_recorder_vehicle_device_event_set = () => {
    //
}

// ==================================================
// ドラレコ設定
// ==================================================
window.drive_recorder_setting_event_set = () => {
    // ====================================================================================================
    // .form-group が指定された要素のクリック時に、フォームの状態を更新します。
    // ====================================================================================================
    $(document).on('click', '.form-group', (event) => {
        const $target = $(event.target);
        const $switch = $(event.currentTarget).find('[data-drive-recorder-setting-on-switch-change="true"]');

        // ==================================================
        // トグルや `input` / `select` / `label` をクリックした場合は無視
        // ==================================================
        if ($target.is($switch) || $target.is('input, select, label')) {
            return;
        }

        // ==================================================
        // トグルがオフの場合のみオンにして `change` 発火
        // ==================================================
        if (!$switch.prop('checked')) {
            $switch.prop('checked', true).trigger('change');
        }
    });

    // ====================================================================================================
    // [data-drive-recorder-setting-on-switch-change="true"] 付き要素の変更時に、フォームの状態を更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-setting-on-switch-change="true"]', (event) => {
        const $switch = $(event.currentTarget);
        const $formGroup = $switch.closest('.form-group');
        const $inputs = $formGroup.find('input[type="text"], input[type="number"]');
        const $selects = $formGroup.find('select');

        if ($switch.is(':checked')) {
            // ==================================================
            // フォームを有効化
            // ==================================================
            $inputs.prop('disabled', false);
            $selects.prop('disabled', false);
        } else {
            // ==================================================
            // `input` の値をリセット
            // ==================================================
            $inputs.each((_, element) => {
                const defaultValue = $(element).data('default');
                $(element).val(defaultValue).trigger('change');
            });

            // ==================================================
            // `select` の値をリセット
            // ==================================================
            $selects.each((_, element) => {
                const defaultValue = $(element).data('default');
                $(element).val(defaultValue).trigger('change');
            });

            // ==================================================
            // フォームを無効化
            // ==================================================
            $inputs.prop('disabled', true);
            $selects.prop('disabled', true);
        }
    });

    // ==================================================
    // [data-drive-recorder-setting-update-vehicle-devices-on-holding-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ==================================================
    $(document).on('change', '[data-drive-recorder-setting-update-vehicle-devices-on-holding-select-change="true"]', (event) => {
        DriveRecorderSettingHandler.updateVehicleDevicesTable(event);
    });

    // ==================================================
    // [data-drive-recorder-setting-update-vehicle-devices-on-company-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ==================================================
    $(document).on('change', '[data-drive-recorder-setting-update-vehicle-devices-on-company-select-change="true"]', (event) => {
        DriveRecorderSettingHandler.updateVehicleDevicesTable(event);
    });

    // ==================================================
    // [data-drive-recorder-setting-update-vehicle-devices-on-section-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ==================================================
    $(document).on('change', '[data-drive-recorder-setting-update-vehicle-devices-on-section-select-change="true"]', (event) => {
        DriveRecorderSettingHandler.updateVehicleDevicesTable(event);
    });

    // ==================================================
    // [data-drive-recorder-setting-update-vehicle-devices-on-model-type-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ==================================================
    $(document).on('change', '[data-drive-recorder-setting-update-vehicle-devices-on-model-type-select-change="true"]', (event) => {
        DriveRecorderSettingHandler.updateVehicleDevicesTable(event);
    });
}

// ==================================================
// ドラレコファーム
// ==================================================
window.drive_recorder_firmware_event_set = () => {
    // ====================================================================================================
    // [data-modal-action-with-file] 付き要素のクリック時に、
    // モーダル内フォーム（ファイル添付可）を `Ajax` で送信します。
    // ====================================================================================================
    $(document).on('click', '[data-modal-action-with-file]', (event) => {
        _error.reset();

        const element = event.currentTarget;
        const modalType = $(element).data('modal-action-with-file');
        const modalId = $(element).data(`modal-action-with-file-${modalType}`);
        const formId = modalId.startsWith('#') ? (modalId + '-form').substring(1) : modalId + '-form';
        const form = document.getElementById(formId);
        const formData = new FormData(form);

        _ajax.file(form.action, formData, (response) => {
            if (response.redirect) {
                location.href = response.redirect;
                return;
            }

            _complete.set(response);
            _modal.hide(modalId);

            load_contents();
        }, (xhr, status, errorThrown) => {
            _error.set(modalId, xhr, status, errorThrown, false);
        });
    });

    // ====================================================================================================
    // [data-firmware-modal-body] 付き要素配下の [data-toggle="tab"] 付きタブの表示時に、
    // 表示ボタンとモードとアクションの切り替えを実行します。
    // ====================================================================================================
    $(document).on('shown.bs.tab', '[data-firmware-modal-body] [data-toggle="tab"]', (event) => {
        const element = event.currentTarget;
        const targetId = $(element).attr('href');
        if (!targetId) {
            console.warn('tab target not found', element);
            return;
        }

        let showButtonIds = [];

        const $modalBody = $(element).closest('[data-firmware-modal-body]');
        const type = $modalBody.data('firmware-modal-body');

        const $form = $(`#modal-${type}-form`);
        if (targetId === `#${type}-version`) {
            showButtonIds.push('#buttons-version');
            $('[data-firmware-modal-body] input[name="mode"]').val($form.data('save-mode'))
            $form.attr('action', $form.data('save-url'));
        } else if (targetId === `#${type}-release`) {
            showButtonIds.push('#buttons-release');
            $('[data-firmware-modal-body] input[name="mode"]').val($form.data('save-and-release-mode'))
            $form.attr('action', $form.data('save-and-release-url'));
        }

        if (targetId === '#edit-version') {
            showButtonIds.push('#buttons-version', '#buttons-revert-release');
        } else if (targetId === '#edit-release') {
            showButtonIds.push('#buttons-release', '#buttons-revert-release');
        }

        $('.footer-buttons').addClass('d-none');
        showButtonIds.forEach((id) => {
            $(id).removeClass('d-none');
        });
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-release-button-on-change="true"] 付き要素の変更時に、
    // リリースボタンとリリース中止ボタンの状態を変更します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-release-button-on-change="true"]', (event) => {
        const value = Number($(event.currentTarget).val());

        const states = {
            100: { release: false, revert: false },
            101: { release: false, revert: true },
            200: { release: true,  revert: true },
            300: { release: true,  revert: true },
        };

        const state = states[value] ?? { release: true, revert: true };

        $('#buttons-release').prop('disabled', state.release);
        $('#buttons-revert-release').prop('disabled', state.revert);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicles-on-holding-select-change="true"] 付き要素の変更時に、
    // 車両のテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicles-on-holding-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehiclesTable(event);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicles-on-company-select-change="true"] 付き要素の変更時に、
    // 車両のテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicles-on-company-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehiclesTable(event);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicles-on-section-select-change="true"] 付き要素の変更時に、
    // 車両のテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicles-on-section-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehiclesTable(event);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicle-devices-on-holding-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicle-devices-on-holding-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehicleDevicesTable(event);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicle-devices-on-company-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicle-devices-on-company-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehicleDevicesTable(event);
    });

    // ====================================================================================================
    // [data-drive-recorder-firmware-update-vehicle-devices-on-section-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ====================================================================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicle-devices-on-section-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehicleDevicesTable(event);
    });

    // ==================================================
    // [data-drive-recorder-firmware-update-vehicle-devices-on-model-type-select-change="true"] 付き要素の変更時に、
    // 車両デバイスのテーブルを更新します。
    // ==================================================
    $(document).on('change', '[data-drive-recorder-firmware-update-vehicle-devices-on-model-type-select-change="true"]', (event) => {
        DriveRecorderFirmwareHandler.updateVehicleDevicesTable(event);
    });
};
